// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HDtZx","tabsBox":"styles_tabsBox__2iA_P","createButton":"styles_createButton__2UBnq"};